import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Navigation bar component
 * @returns {JSX.Element} Navigation bar
 */
const Navbar = () => {
  const { user, signOut } = useAuth();
  
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  const navStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    backgroundColor: '#1a1a1a', // Dark background
    borderBottom: '1px solid #333', // Darker border
    color: '#ffffff', // White text
  };

  const logoStyle = {
    textDecoration: 'none',
  };

  const linkStyle = {
    textDecoration: 'none',
    color: '#2980B9',
    fontWeight: 'bold',
  };

  const buttonStyle = {
    padding: '8px 12px',
    backgroundColor: '#2980B9',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  };
  
  return (
    <nav style={navStyle}>
      <div>
        <Link to="/" style={logoStyle}>
          <h2 style={{ margin: 0 }}>
            <span style={{ color: "#2980B9" }}>cis</span>
            <span style={{ color: "#CE93D8" }}>fuss</span>
          </h2>
        </Link>
      </div>
      
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        {user ? (
          <>
            <Link to="/saved" style={linkStyle}>
              Saved Jobs
            </Link>
            <Link to="/account" style={linkStyle}>
              Account Settings
            </Link>
            <button onClick={handleSignOut} style={buttonStyle}>
              Sign Out
            </button>
          </>
        ) : (
          <Link to="/login" style={linkStyle}>
            Sign In / Sign Up
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;